import { Component, Optional, Inject } from '@angular/core';

@Component({
    selector: 'nxi-google-analytics',
    template: ''
})

export class GoogleAnalyticsComponent {
    googleAnalytics: string;
    pershingGoogleAnalytics: string;

    constructor(@Optional() @Inject('AppSettings') appSettings: any) {
        this.googleAnalytics = (appSettings && appSettings.ibdConfigMap && appSettings.ibdConfigMap.googleAnalyticsCode) ? appSettings.ibdConfigMap.googleAnalyticsCode : '';
        this.pershingGoogleAnalytics = (appSettings && appSettings.ibdConfigMap && appSettings.ibdConfigMap.pershingGoogleAnalyticsCode) ? appSettings.ibdConfigMap.pershingGoogleAnalyticsCode : '';
        if ((this.pershingGoogleAnalytics || this.googleAnalytics) && !appSettings.isAdvisor) {
            this.acknowledgeGoogleAnalyticsToTrack();
        }
    }

    acknowledgeGoogleAnalyticsToTrack() {
        try {
            const pershingGoogleSrc = document.createElement('script');
            if (this.pershingGoogleAnalytics) {
                pershingGoogleSrc.async = true;
                pershingGoogleSrc.src =
                    `https://www.googletagmanager.com/gtag/js?id=` +
                    this.pershingGoogleAnalytics;
            }
            const googleSrc = document.createElement('script');
            if (this.googleAnalytics) {
                googleSrc.async = true;
                googleSrc.src =
                    `https://www.googletagmanager.com/gtag/js?id=` +
                    this.googleAnalytics;
            }
            const googleScript = document.createElement('script');
            let scriptHtml =
                `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                `;
            if (this.pershingGoogleAnalytics) {
                scriptHtml +=
                    `
                    gtag('config', '` + this.pershingGoogleAnalytics + `');
                    `;
            }
            if (this.googleAnalytics) {
                scriptHtml +=
                    `
                    gtag('config', '` + this.googleAnalytics + `');
                    `;
            }
            googleScript.innerHTML = scriptHtml;
            if (this.googleAnalytics) document.head.appendChild(googleSrc);
            if (this.pershingGoogleAnalytics) document.head.appendChild(pershingGoogleSrc);
            document.head.appendChild(googleScript);
        } catch (ex) {
            console.error('Error appending google analytics');
            console.error(ex);
        }
    }
}
